//Salary Components Types
export const CUSTOM_EARNINGS = 'customEarnings'
export const CUSTOM_DEDUCTIONS = 'customDeductions'
export const REIMBURSEMENTS = 'reimbursements'
export const STANDARD_EARNINGS = 'standardEarnings'
export const STATUTORY_DEDUCTIONS = 'statutoryDeductions'

//Pagination
export const PAGE_LIMIT = 10
